<template>
  <font-awesome-icon title="Отменить допуск" @click="newAccess" class="submit hover" icon="fa-solid fa-hand" />
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'denied-executor',
  props: ['id','name'],
  setup(props) {
    const store = useStore()

    const newAccess = () =>{
      const form = {id:props.id,[props.name]:false}
      store.dispatch('apiStorage/updateItem',{model:'executors',form})
    }
    return {
      newAccess
    }
  }
};
</script>

<style scoped>

.submit{
  width: 25px;
  height: 25px;
  margin-right: 10px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 4px;
  border-radius: 5px;
  color: rgba(239,43,43,0.8);
}

.hover:hover{
  background-color: rgba(230,230,230, 1);
  cursor: pointer;
}
</style>
